const TAILWIND_INPUT_CLASS_NAME = 'w-full h-9 block rounded-lg border dark:border-none dark:bg-gray-800 py-[9px] px-3 text-sm focus:border-blue-400 focus:ring-1 focus:ring-blue-400 focus:outline-none';

export { TAILWIND_INPUT_CLASS_NAME };